import { Region } from '@water-web/types';

import { SelectedCookieSections } from '../../../../types';

export const getRegionalDefaults = (region: Region): SelectedCookieSections => {
  switch (region) {
    case 'US':
      return {
        necessary: true,
        statistics: true,
      };
    case 'EU':
    case 'CA':
    case 'OTHER':
    default:
      return {
        necessary: true,
        statistics: false,
      };
  }
};
